// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__2OwB0","range":"MonthRangeSwitch_range__IngF5","disabled":"MonthRangeSwitch_disabled__3kLcn"};